import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/settle-account-list',
      name: 'admin-settle-account-list',
      component: () => import(/* webpackChunkName: "page-admin-settle-management-settle-account-list" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "结算列表"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "结算管理"
                                        },
                                        {
                                                  name: "结算列表"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
